import { LOG_IN_APPROVAL_SUCCESS } from "../constants";

const initialState = {
  list: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
  case LOG_IN_APPROVAL_SUCCESS:
    return {
      ...state,
      list: action.payload
    };
  default:
    return state;
  }
}